import { Command } from 'commander'
import { createClient } from '../../client.js'
import { handleError } from '../../lib/errors.js'
import { isQuiet, printQuiet, printJson, printTable } from '../../output.js'

export const servicesListCommand = new Command(`list`)
  .usage(`--environment <id>`)
  .description(`List services in an environment`)
  .requiredOption(`--environment <id>`, `Environment ID`)
  .action(async (opts) => {
    const json = servicesListCommand.parent?.parent?.opts().json ?? false
    try {
      const client = createClient()
      const result = await client.services.list({
        environmentId: opts.environment,
      })

      if (isQuiet()) {
        for (const s of result.services) {
          printQuiet(s.id)
        }
        return
      }

      if (json) {
        printJson(result)
      } else {
        printTable(
          [`ID`, `Name`, `Type`],
          result.services.map((s) => [s.id, s.name, s.type])
        )
      }
    } catch (error) {
      await handleError(error, json)
    }
  })
